/** @jsxImportSource @emotion/react */
import * as S from "./style";

const CategoriesSection = () => {
  return (
    <section css={S.root}>
      <div css={S.inner}>
        <div css={S.topGrid}>
          <a href="/vintage" css={S.card}>
            <img
              css={S.image}
              src="/images/category-vintage.jpg"
              alt="Вінтаж"
            />
            <span css={S.label}>ВІНТАЖ</span>
          </a>

          <a href="/bags" css={S.card}>
            <img css={S.image} src="/images/category-bags.jpg" alt="Сумки" />
            <span css={S.label}>СУМКИ</span>
          </a>
        </div>

        <div css={S.middleBanner}>MAKE ENTRUPY WITH PARTNERS</div>

        <div css={S.bottomGrid}>
          <a href="/clothes" css={S.card}>
            <img css={S.image} src="/images/category-clothes.jpg" alt="Одяг" />
            <span css={S.label}>ОДЯГ</span>
          </a>

          <a href="/accessories" css={S.card}>
            <img
              css={S.image}
              src="/images/category-accessories.jpg"
              alt="Аксесуари"
            />
            <span css={S.label}>АКСЕСУАРИ</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
